module.exports = __webpack_public_path__ + "img/companylogo_ws.e5d3bd19.png";